import { ReactNode } from "react";
import { Button } from "./Button";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";

export { ToggleButton, Props as ToggleButtonProps };

type Props = {
  /**
   * class names
   */
  className?: string;
  /**
   * Controls how component is displayed.
   */
  active: boolean;
  onClick: () => void;
  /**
   * Text element to display within the button.
   */
  children: ReactNode;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

/**
 * Component to provide default Toggle Button to parent.
 * @param props
 * @returns
 */
const ToggleButton = (props: Props) => {
  return (
    <Button
      className={props.className ?? ""}
      onClick={props.onClick}
      {...props.tProps}
    >
      {props.children}
    </Button>
  );
};
